export const SERVER_URL = process.env.REACT_APP_IS_PROD === 'true'
  ? 'https://api.gc.aigrus.ru'
  : 'https://gc-api.genisoft.ru';
